import { Component } from '@angular/core';
import { ResumeUpdaterService } from '../../../cart/services/cart-resume-updater.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'payment-payment-coupon',
    templateUrl: './payment.payment.coupon.component.html',
    styleUrls: []
})
export class PaymentPaymentCouponComponent {
    public inputting = false;
    public couponCode: string;
    public loading = false;
    public valid = false;

    constructor(
        protected resumeUpdaterService: ResumeUpdaterService,
        protected toastr: ToastrService,
        protected translate: TranslateService
    ) {
        this.resumeUpdaterService.validatingCoupon$.subscribe(() => {
            this.loading = true;
        });
        this.resumeUpdaterService.validatedCoupon$.subscribe(() => {
            this.loading = false;
            this.inputting = false;
            this.valid = true;
        });
        this.resumeUpdaterService.invalidCoupon$.subscribe(() => {
            this.loading = false;
            this.translate
                .get([
                    'CART.ROW.ERRORS.INVALID_COUPON.TITLE',
                    'CART.ROW.ERRORS.INVALID_COUPON.MESSAGE'
                ])
                .subscribe(translated => {
                    this.toastr.error(
                        translated['CART.ROW.ERRORS.INVALID_COUPON.MESSAGE'],
                        translated['CART.ROW.ERRORS.INVALID_COUPON.TITLE'],
                        {}
                    );
                });
        });
    }
    /** Validate coupon code at API */
    public validate() {
        if (this.couponCode !== undefined && this.couponCode !== '') {
            this.resumeUpdaterService
                .updateByCouponCode(this.couponCode)
                .subscribe();
        }
    }
    /** Remove coupon passing to API coupon code as null */
    public remove() {
        this.resumeUpdaterService
            .removeCouponCode()
            .subscribe(() => {
                this.cancel();
            });
    }
    /** Resetting properties to initial state */
    public cancel() {
        this.inputting = false;
        this.couponCode = '';
        this.loading = false;
        this.valid = false;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/payment/coupon/payment.payment.coupon.component.ts